import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule , Title} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DayComponent } from './day/day.component';
import { DatePipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import { LoginComponent } from './login/login.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { RegisterComponent } from './register/register.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';
import { CreatePostComponent } from './create-post/create-post.component';
import { MatSelectModule } from '@angular/material/select';
import { AuthGuardService } from './core/authguard.service';
import { ModifyPostComponent } from './modify-post/modify-post.component';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation.service';
import { TokenInterceptor } from './core/token.inceptior';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import { MessageFeedDialogComponent } from './message-feed-dialog/message-feed-dialog.component';
import { MessageFeedDialogService } from './message-feed-dialog/message.feed.service';

registerLocaleData(localeHu);

@NgModule({
  declarations: [
    AppComponent,
    CalendarComponent,
    DayComponent,
    LoginComponent,
    RegisterComponent,
    DialogComponent,
    CreatePostComponent,
    ModifyPostComponent,
    ConfirmationDialogComponent,
    MessageFeedDialogComponent,
  ],
  imports: [
    BrowserModule,
    MatToolbarModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    NgbModalModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    NgbModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    HttpClientModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCardModule,
    MatListModule,
    MatDialogModule,
    MatSelectModule,
    NgxWebstorageModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    MatDatepickerModule,
    MatButtonModule,
    MatNativeDateModule,
  ],
  providers: [DatePipe, AuthGuardService, Title, {provide: LOCALE_ID, useValue: 'hu'}, ConfirmationDialogService, MessageFeedDialogService,{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }], 
  bootstrap: [AppComponent]
})
export class AppModule { }
